import { useI18n } from '../i18n'

export function DatenschutzPage() {
  const { t } = useI18n()
  return (
    <div className="mx-auto max-w-2xl px-4 py-12">
      <h1 className="mb-6 text-2xl font-bold text-text">{t('footer.datenschutz')}</h1>
      <div className="text-sm text-text-muted space-y-4 leading-relaxed">
        <p className="text-text font-semibold">Datenschutzerklaerung</p>

        <p>
          <strong className="text-text">Verantwortlicher:</strong><br />
          Joey Masterlevel, jav@masterlevel.de
        </p>

        <p>
          <strong className="text-text">Erhobene Daten:</strong><br />
          Bei der Registrierung werden E-Mail-Adresse und Benutzername gespeichert.
          Beim Scannen eines QR-Codes werden IP-Adresse, Geraetetyp und Browser anonymisiert protokolliert.
        </p>

        <p>
          <strong className="text-text">Zweck:</strong><br />
          Die Daten werden ausschliesslich zur Bereitstellung des Dienstes und zur Anzeige von Scan-Statistiken genutzt.
          Eine Weitergabe an Dritte erfolgt nicht.
        </p>

        <p>
          <strong className="text-text">Loeschung:</strong><br />
          Du kannst jederzeit die Loeschung deines Kontos und aller gespeicherten Daten per E-Mail an
          jav@masterlevel.de beantragen.
        </p>

        <p>
          <strong className="text-text">Cookies:</strong><br />
          Dieses Tool verwendet keine Tracking-Cookies. Der Login-Token wird im localStorage des Browsers gespeichert.
        </p>
      </div>
    </div>
  )
}
